export const SET_BAGE_COUNT = 'SET_BAGE_COUNT';
